import AddUserModal from './AddUserModalFormContainer'

export default AddUserModal



// WEBPACK FOOTER //
// ./src/components/AddUserModalForm/index.js